var map = {
	"./image01a": 96741,
	"./image01a.png": 96741,
	"./image01b": 26382,
	"./image01b.png": 26382,
	"./image02a": 89000,
	"./image02a.png": 89000,
	"./image02b": 25859,
	"./image02b.png": 25859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44779;